import React, { useState, useEffect } from 'react';
import CommonTable from '../../components/commonComponent/CommanTable';
import CommonModalForm from '../../components/commonComponent/CommonModalForm';
import axios from '../../utils/axiosInstance';
import { toastSuccess, toastError, confirmDelete } from '../../utils/alertHelper';
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa';

const tabConfig = [
  {
    key: 'unit',
    label: 'Unit',
    addLabel: 'Add New Unit',
    columns: [
      { key: 'srNo', label: 'Sr.no:' },
      { key: 'name', label: 'Unit Name' },
      { key: 'actions', label: 'Action' },
    ],
    modalFields: [
      { name: 'name', label: 'Unit Name', type: 'text', placeholder: 'Enter Unit Name' },
    ],
    initialValues: { name: '' },
    requiredFields: ['name'],
    sampleRow: { name: 'Piece' },
  },
  {
    key: 'group',
    label: 'Group',
    addLabel: 'Add New Group',
    columns: [
      { key: 'srNo', label: 'Sr.no:' },
      { key: 'name', label: 'Group Name' },
      { key: 'actions', label: 'Action' },
    ],
    modalFields: [
      { name: 'name', label: 'Group Name', type: 'text', placeholder: 'Enter Group Name' },
    ],
    initialValues: { name: '' },
    requiredFields: ['name'],
    sampleRow: { name: 'Default Group' },
  },
  {
    key: 'category',
    label: 'Category',
    addLabel: 'Add New Category',
    columns: [
      { key: 'srNo', label: 'Sr.no:' },
      { key: 'name', label: 'Category Name' },
      { key: 'actions', label: 'Action' },
    ],
    modalFields: [
      { name: 'name', label: 'Category Name', type: 'text', placeholder: 'Enter Category Name' },
    ],
    initialValues: { name: '' },
    requiredFields: ['name'],
    sampleRow: { name: 'Default Category' },
  },
  {
    key: 'gst',
    label: 'Tax',
    addLabel: 'Add New Gst',
    columns: [
      { key: 'srNo', label: 'Sr.no:' },
      { key: 'gstName', label: 'GST Name' },
      { key: 'rate', label: 'Rate' },
      { key: 'tax', label: 'Tax Type' },
      { key: 'actions', label: 'Action' },
    ],
    modalFields: [
      {
        name: 'gstName',
        label: 'Tax Name',
        type: 'text',
        placeholder: 'Enter Tax Name',
      },
      {
        name: 'rate',
        label: 'Persantage',
        type: 'Number',
        placeholder: 'Enter Persantage (%)',
      },
      {
        name: 'tax',
        label: 'Tax Type',
        type: 'select',
        options: [
          { value: 'SGST', label: 'SGST' },
          { value: 'CGST', label: 'CGST' },
          { value: 'IGST', label: 'IGST' },
          { value: 'UTGST', label: 'UTGST' },
          { value: 'OTHER', label: 'OTHER' },
        ],
        placeholder: 'Select Tax Type',
      },
    ],
    initialValues: { gstName: '', rate: '', tax: '' },
    requiredFields: ['gstName', 'rate', 'tax'],
    sampleRow: { gstName: 'Standard GST', rate: '18%'},
  },
  // {
  //   key: 'types',
  //   label: 'Types',
  //   addLabel: 'Add New Types',
  //   columns: [
  //     { key: 'srNo', label: 'Sr.no:' },
  //     { key: 'name', label: 'Types Name' },
  //     { key: 'actions', label: 'Action' },
  //   ],
  //   modalFields: [
  //     { name: 'name', label: 'Types Name', type: 'text', placeholder: 'Enter Types Name' },
  //   ],
  //   initialValues: { name: '' },
  //   requiredFields: ['name'],
  //   sampleRow: { name: 'Default Type' },
  // },
];

const apiMap = {
  gst: '/admin/api/item-tax',
  group: '/admin/api/item-group',
  category: '/admin/api/itemCategory',
  unit: '/admin/api/item-unit',
  types: '/admin/api/item-type',
};

function ItemManage() {
  const [activeTab, setActiveTab] = useState('unit'); // Set to 'unit' since it's the only active tab
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ name: '' }); // Initialize with unit's initial values
  const [modalMode, setModalMode] = useState('single'); // 'single' for regular add/edit, 'group' for tax-group modal
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [groupModalData, setGroupModalData] = useState({ name: '', taxes: [] });
  const [groupErrors, setGroupErrors] = useState({});
  const [availableTaxes, setAvailableTaxes] = useState([]);
  const [groupFields, setGroupFields] = useState([
    { name: 'name', label: 'Group Name', type: 'text', placeholder: 'Enter Group Name' },
  ]);
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  
  
  useEffect(() => {
    fetchTabData(activeTab);
    // eslint-disable-next-line
  }, [activeTab]);

  async function fetchTabData(tabKey) {
    setLoading(true);
    try {
      const res = await axios.get(`${apiMap[tabKey]}`);
      let items = [];

      switch (tabKey) {
        case 'unit':
          items = res.data.units || [];
          break;
          case 'group':
          items = res.data.groups || [];
          break;
          case 'category':
          items = res.data.categories || [];
          break;
          case 'gst':
            const gstList = res.data.taxes || res.data.gsts || res.data.items || [];
            items = gstList.map((item) => ({
              ...item,
              gstName: item.name,
              rate: item.percentage,
              tax: item.gstType,
            }));
          break;
        // case 'types':
        //   items = res.data.types || [];
        //   break;
        default:
          items = [];
      }

      setData((prev) => ({
        ...prev,
        [tabKey]: items.map((item, idx) => ({
          srNo: idx + 1,
          ...item,
        })),
      }));
    } catch (err) {
      setData((prev) => ({ ...prev, [tabKey]: [] }));
    } finally {
      setLoading(false);
    }
  }

  const currentTab = tabConfig.find((tab) => tab.key === activeTab);

  // Safety check: if currentTab is undefined, return early with error message
  if (!currentTab) {
    return (
      <div className="container-fluid mt-4">
        <div className="alert alert-danger" role="alert">
          Invalid tab configuration. Please check the tab settings.
        </div>
      </div>
    );
  }

  const iconHoverStyle = {
    transition: 'color 0.2s',
    cursor: 'pointer',
  };

  const rows = (data[activeTab] || [])
    .filter((row) => {
      if (activeTab === 'gst') {
        return (
          row.gstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          row.rate?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
          row.tax?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      } else {
        return row.name?.toLowerCase().includes(searchTerm.toLowerCase());
      }
    })
    .map((row, idx) => ({
      ...row,
      actions: (
        <div>
          <span
            style={iconHoverStyle}
            onMouseEnter={(e) => (e.currentTarget.style.color = '#0d6efd')}
            onMouseLeave={(e) => (e.currentTarget.style.color = '')}
          >
            <button
              className="btn btn-sm me-1 py-0 px-1 fs-6 lh-sm shadow-none border-0 text-primary-custom"
              title="Edit"
              onClick={() => handleEdit(idx)}
              style={{ background: 'none', padding: 0, border: 'none' }}
            >
              <FaPencilAlt size={14} />
            </button>
          </span>
        </div>
      ),
    }));

  function handleAdd() {
    setModalMode('single');
    setModalData(currentTab.initialValues);
    setErrors({});
    setShowModal(true);
  }

  // Open the tax-group modal (GST tab only)
  async function handleAddGroup() {
    setModalMode('group');
    setGroupErrors({});
    setShowGroupModal(true);

    // Load available taxes for checkbox list
    try {
      // prefer the dedicated tax list endpoint
      const res = await axios.get('/admin/api/item-tax/tax');
      const gstList = res.data.tax || res.data.taxes || res.data.gsts || res.data.items || [];
      const items = gstList.map((item) => ({
        value: item._id,
        label: `${item.name || item.gstName || ''}${(item.percentage || item.rate) ? ` (${item.percentage || item.rate})` : ''}`,
      }));
      setAvailableTaxes(items);

      // Build individual checkbox fields for each tax
      const fields = [
        { name: 'name', label: 'Group Name', type: 'text', placeholder: 'Enter Group Name' },
        ...items.map((t) => ({ name: `tax_${t.value}`,  type: 'checkbox', placeholder: t.label })),
      ];
      setGroupFields(fields);

      // Initialize groupModalData with checkbox keys set to false
      const init = { name: '' };
      items.forEach((t) => { init[`tax_${t.value}`] = false; });
      setGroupModalData(init);
    } catch (err) {
      setAvailableTaxes([]);
      setGroupFields([{ name: 'name', label: 'Group Name', type: 'text', placeholder: 'Enter Group Name' }]);
      setGroupModalData({ name: '' });
    }
  }

  async function handleEdit(idx) {
    const editRow = data[activeTab]?.[idx];
    if (!editRow) return;
    const { actions, srNo, ...rawData } = editRow;

    // If GST tab and this row is a tax-group, open the group modal with checkboxes prefilled
    const isGroup = activeTab === 'gst' && (rawData.recordType === 'tax_group' || rawData.recordType === 'tax-group' || Array.isArray(rawData.taxes));
    if (isGroup) {
      setModalMode('group');
      setGroupErrors({});
      try {
        const res = await axios.get('/admin/api/item-tax/tax');
        const gstList = res.data.tax || res.data.taxes || res.data.gsts || res.data.items || [];
        const items = gstList.map((item) => ({
          value: item._id,
          label: `${item.name || item.gstName || ''}${(item.percentage || item.rate) ? ` (${item.percentage || item.rate})` : ''}`,
        }));
        setAvailableTaxes(items);

        const fields = [
          { name: 'name', label: 'Group Name', type: 'text', placeholder: 'Enter Group Name' },
          ...items.map((t) => ({ name: `tax_${t.value}`, type: 'checkbox', placeholder: t.label })),
        ];
        setGroupFields(fields);

        // prepare initial groupModalData with selected taxes checked
        const init = { name: rawData.name || '', _id: rawData._id };
        const existingTaxIds = Array.isArray(rawData.taxes) ? rawData.taxes.map((t) => (t._id || t.id || t).toString()) : [];
        items.forEach((t) => {
          init[`tax_${t.value}`] = existingTaxIds.includes(String(t.value));
        });
        setGroupModalData(init);
        setShowGroupModal(true);
      } catch (err) {
        // fallback to single modal if tax list fetch fails
        setModalMode('single');
        setModalData(rawData);
        setErrors({});
        setShowModal(true);
      }
      return;
    }

    setModalMode('single');
    setModalData(rawData);
    setErrors({});
    setShowModal(true);
  }

  async function handleDelete(idx) {
    const item = data[activeTab]?.[idx];
    if (!item || !item._id) return;
    try {
      const res = await confirmDelete(`Are you sure you want to delete ${item.name || item.gstName || ''}?`);
      if (!res.isConfirmed) return;

        await axios.delete(`${apiMap[activeTab]}/${item._id}`);
      toastSuccess('Deleted successfully');
      fetchTabData(activeTab);
    } catch (err) {
      console.error('Delete failed', err);
      toastError('Failed to delete. Please try again.');
    }
  }

  async function handleSubmit() {
    const newErrors = {};
    currentTab.requiredFields.forEach((f) => {
      if (!modalData[f]) newErrors[f] = 'Required';
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length) return;

    const { actions, srNo, ...payload } = modalData;

    if (activeTab === 'gst') {
      // Map frontend modal fields to backend expected fields
      payload.name = payload.gstName;
      payload.percentage = payload.rate;
      payload.gstType = payload.tax;
      delete payload.gstName;
      delete payload.rate;
      delete payload.tax;
    }

    try {
      if (modalData._id) {
        await axios.put(`${apiMap[activeTab]}/${modalData._id}`, payload);
      } else {
        await axios.post(apiMap[activeTab], payload);
      }
      fetchTabData(activeTab);
      setShowModal(false);
      setModalData(currentTab.initialValues);
    } catch (err) { }
  }

  async function handleGroupSubmit() {
    const newErrors = {};
    if (!groupModalData.name) newErrors.name = 'Required';
    setGroupErrors(newErrors);
    if (Object.keys(newErrors).length) return;

    // Collect selected taxes from checkbox fields (keys that start with 'tax_')
    const selectedTaxes = Object.keys(groupModalData)
      .filter((k) => k.startsWith('tax_') && groupModalData[k])
      .map((k) => k.replace(/^tax_/, ''));

    const payload = {
      name: groupModalData.name,
      taxes: selectedTaxes,
      recordType: 'tax_group',
    };

    try {
      // Use PUT for updates and POST for creation
      if (groupModalData._id) {
        await axios.put(`/admin/api/item-tax/group/${groupModalData._id}`, payload);
      } else {
        await axios.post('/admin/api/item-tax/group', payload);
      }
      toastSuccess('Tax group saved');
      setShowGroupModal(false);
      setGroupModalData({ name: '', taxes: [] });
      // Refresh GST tab data so new/updated group appears if applicable
      fetchTabData('gst');
    } catch (err) {
      console.error('Failed to save tax group', err);
      toastError('Failed to save tax group');
    }
  }

  function handleGroupCancel() {
    setShowGroupModal(false);
    setGroupModalData({ name: '', taxes: [] });
    setGroupErrors({});
  }

  function handleCancel() {
    setShowModal(false);
    setModalData(currentTab.initialValues);
    setErrors({});
  }

  const tabHoverStyle = {
    transition: 'color 0.2s, background 0.2s',
    cursor: 'pointer',
  };

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4 mt-4">
        <h2 className="h2 mb-0 text-dark">Item Setting</h2>
        <div className="d-flex gap-3 align-items-center flex-wrap">
          <button
            className="btn btn-primary"
            onClick={handleAdd}
            style={{
              fontSize: '15px',
              borderRadius: '6px',
              whiteSpace: 'nowrap',
            }}
          >
            + Add New {currentTab.label}
          </button>
          {/* For GST tab show second button to add tax group */}
          {activeTab === 'gst' && (
            <button
              className="btn btn-secondary"
              onClick={handleAddGroup}
              style={{
                fontSize: '14px',
                borderRadius: '6px',
                whiteSpace: 'nowrap',
              }}
            >
              + Add Tax Group
            </button>
          )}
          {/* Show Add Default button ONLY when no data and type is unit */}
          
        </div>
      </div>

      {/* ===== Tabs + Search (Same Line) ===== */}
      <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">

        {/* ===== Tabs Section - Only show if more than one tab ===== */}
        {tabConfig.length > 1 && (
        <div className="d-flex gap-2 mb-2 tab-menu">
          {tabConfig.map((tab) => (
            <button
              key={tab.key}
              className={`tab-btn ${activeTab === tab.key ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      )}
        {/* ===== Search Section (Right Side) ===== */}
        <div className="input-group" style={{ maxWidth: '250px', marginLeft: tabConfig.length === 1 ? 'auto' : '0' }}>
          <span className="input-group-text bg-white border-end-0">
            <i className="fas fa-search text-muted"></i>
          </span>
          <input
            type="text"
            className="form-control border-start-0"
            placeholder="Type to search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              boxShadow: 'none',
              fontSize: '14px',
            }}
          />
        </div>
      </div>


      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
      <CommonTable
        columns={currentTab.columns}
        data={rows}
      />
      )}

      <CommonModalForm
        visible={showModal}
        title={modalData._id ? `Edit ${currentTab.label}` : `Add New ${currentTab.label}`}
        fields={currentTab.modalFields}
        values={modalData}
        onChange={setModalData}
        onCancel={handleCancel}
        onSubmit={handleSubmit}
        errors={errors}
        requiredFields={currentTab.requiredFields}
        submitLabel={modalData._id ? 'Update' : 'Save'}
        cancelLabel="Cancel"
      />

      {/* Tax Group Modal (uses CommonModalForm) */}
      <CommonModalForm
        visible={showGroupModal}
        title={groupModalData._id ? `Edit Tax Group` : `Add Tax Group`}
        fields={groupFields}
        values={groupModalData}
        onChange={(vals) => setGroupModalData(vals)}
        onCancel={handleGroupCancel}
        onSubmit={handleGroupSubmit}
        errors={groupErrors}
        requiredFields={['name']}
        submitLabel={groupModalData._id ? 'Update' : 'Save Group'}
        cancelLabel="Cancel"
      />
    </div>
  );
}

export default ItemManage;
